import { render, staticRenderFns } from "./ApiBbee.vue?vue&type=template&id=cd22d29e"
import script from "./ApiBbee.vue?vue&type=script&lang=js"
export * from "./ApiBbee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports